import React,{useRef} from 'react'
import {useSelector,useDispatch,batch} from 'react-redux'
import PopupAbout from './PopupAbout'
import PopupHowToUseDatabase from './PopupHowToUseDatabase'
import PopupHowToContribute from './PopupHowToContribute'
import PopupPartners from './PopupPartners'
import PopupLogin from './PopupLogin'
import PopupRegister from './PopupRegister'
import PopupPermission from './PopupPermission'

function closeThis(setApp,ref){
  ref.current.style.opacity = 0;
  setTimeout(()=>{
    setApp({
      type:'_POPUP',
      payload: ['popup',!1]
    })
  },250)

}

const PopupDefault = () => {

  const setApp = useDispatch()
  const {popup} = useSelector(s=>s.popup)
  const popupDefaultRef = useRef()

  return (
    <div ref={popupDefaultRef} className="popup full-p" style={{display:`${popup ? '' : 'none'}`,opacity:`${popup ? 1 : 0}`}}>
      <div role='presentation' className="popup-bg" onClick={()=>closeThis(setApp,popupDefaultRef)}/>
      <div style={popup === 'Login' || popup === 'Register' || popup === 'Permission' ? {maxWidth: 600} : {}}>
        <div>
          <div className="popup-header">
            <div>{popup}</div>
            <div role='presentation' onClick={()=>closeThis(setApp,popupDefaultRef)} className="cursor-pointer"><i className="fa fa-times"></i></div>
          </div>
          <div className="popup-inner" style={popup === 'Login' || popup === 'Register' ? {background: '#f9f9f9'} : {}}>
            <PopupAbout show={popup}/>
            <PopupHowToUseDatabase show={popup}/>
            <PopupHowToContribute show={popup}/>
            <PopupPartners show={popup}/>
            <PopupLogin show={popup}/>
            <PopupRegister show={popup}/>
            <PopupPermission show={popup}/>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PopupDefault
